// import React, { Component } from "react";

// import { Input, Icon } from "antd";
// import { number } from "style-value-types";
// class Currency extends Component {
//   constructor(props) {
//     super(props);
//     let propsVal = ("" + props.value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

//     this.state = {
//       value: propsVal,
//       numberVal: 0,
//     };

//     this.handleInputChange = this.handleInputChange.bind(this);
//   }

//   componentDidMount() {
//     // let formatVal = ('' + this.props.value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//     let formatVal = "" + this.props.value;

//     if (formatVal == "null") {
//       formatVal = "";
//     }

//     this.setState({
//       value: formatVal,
//     });
//   }

//   componentDidUpdate(prevProps) {
//     if (prevProps.value == "" || prevProps.value) {
//       var prevVal;
//       var parseVal;
//       if (prevProps.value != null) {
//         parseVal = ("" + prevProps.value).replace(/\$\s?|(,*)/g, "");
//         prevVal = parseVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         prevVal = Number(prevVal.replace(/[^0-9\.-]+/g, ""));
//       }

//       var newVal;
//       if (this.props.value != null) {
//         parseVal = ("" + this.props.value).replace(/\$\s?|(,*)/g, "");
//         newVal = parseVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         newVal = Number(newVal.replace(/[^0-9\.-]+/g, ""));
//       }

//       if (prevVal != newVal) {
//         if (this.props.value != null || this.props.value != "") {
//           parseVal = ("" + this.props.value).replace(/\$\s?|(,*)/g, "");
//           let newvalue = parseVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

//           if (newvalue == "null") {
//             newvalue = "";
//           }
//           this.setState({
//             value: newvalue,
//           });
//         }
//       }
//     }
//   }

//   // handleInputChange(event){
//   //     event.preventDefault();
//   //     const {name, value} = event.target;
//   //     // this.handleFormInputChange(name, value);

//   //     let parseValue = value.replace(/\$\s?|(,*)/g, '');
//   //     let newvalue = parseValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   //     const result = value.replace(/\D/g, '');
//   //     let numberVal = Number(newvalue.replace(/[^0-9\.-]+/g,""));
//   //     let decimalNumber= value.replace(/^-?\D*(\.\D*)?$/, '')
//   //     // let decimalNumber= value.match(/^(\d*)(\.\d*)?$/g)
//   //     const re = /^(\d*)(\.\d*)?$/g;

//   //     if (value === "" || re.test(value)) {

//   //     this.setState({
//   //         value: decimalNumber,
//   //         numberVal: numberVal
//   //     })
//   // }
//   //     event.target.value = numberVal;
//   //     if(this.props.onChange){
//   //         this.props.onChange(event);
//   //     }

//   // }
//   handleInputChange(event) {
//     event.preventDefault();
//     const { name, value } = event.target;
//     // Remove any characters that are not digits, a decimal point, or a minus sign
//     let cleanValue = value.replace(/[^0-9\.-]+/g, "");
//     console.log("cleanValue", cleanValue);
//     const [integerPart, decimalPart] = cleanValue.split(".");
//     const formattedIntegerPart =
//       parseFloat(integerPart).toLocaleString("en-US");
//     console.log("formattedIntegerPart", formattedIntegerPart);

//     const formattedValue = decimalPart
//       ? `${formattedIntegerPart}.${decimalPart}`
//       : formattedIntegerPart;
//     console.log("formattedValue", formattedValue);
//     console.log("parseFloat(cleanValue)", parseFloat(cleanValue));
//     this.setState({
//       value: formattedValue && formattedValue,
//     });
//     if (this.props.onChange) {
//       // Update the event target value with the formatted value
//       event.target.value = formattedValue;
//       this.props.onChange(event);
//     }
//   }

//   render() {
//     return (
//       <div>
//         <Input
//           style={this.props.style ? this.props.style : null}
//           addonBefore={"$"}
//           placeholder="#,###,###.##"
//           value={this.state.value}
//           name={this.props.name}
//           onChange={this.handleInputChange}
//           disabled={this.props.disabled}
//           size={"large"}
//         />
//       </div>
//     );
//   }
// }

// export default Currency;

// import React, { useEffect, useState } from "react";
// import { Input } from "antd";
// const Currency = (props) => {
//   const [value, setValue] = useState("");
//   const formatValue = (val) => {
//     if (val != null && val !== "") {
//       const parseVal = ("" + val).replace(/\$\s?|(,*)/g, "");
//       return parseVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     }
//     return "";
//   };
//   useEffect(() => {
//     setValue(formatValue(props.value));
//   }, [props.value]);
//   const handleInputChange = (event) => {
//     event.preventDefault();
//     const { name, value } = event.target;
//     let cleanValue = value.replace(/[^0-9.-]+/g, "");
//     const [integerPart, decimalPart] = cleanValue.split(".");
//     console.log( "decimalPart",decimalPart,"integerPart",integerPart)

//     const formattedIntegerPart = parseFloat(integerPart).toLocaleString("en-US");
//     const formattedValue = decimalPart
//       ? `${formattedIntegerPart}.${decimalPart}`
//       : formattedIntegerPart;
//       console.log("formattedValue",formattedValue)
//     //   console.log("cleanValue",cleanValue, "decimalPart",decimalPart,"integerPart",integerPart,"formattedValue",formattedValue)

//     setValue(value);
//     if (props.onChange) {
//       event.target.value = formattedValue;
//       props.onChange(event);
//     }
//   };
//   return (
//     <div>
//       <Input
//         style={props.style ? props.style : null}
//         addonBefore={"$"}
//         placeholder="#,###,###.##"
//         value={value}
//         name={props.name}
//         onChange={handleInputChange}
//         disabled={props.disabled}
//         size={"large"}
//       />
//     </div>
//   );
// };
// export default Currency;

import React, { useEffect, useState } from "react";
import { Input } from "antd";
const Currency = (props) => {
  const [value, setValue] = useState("");
  const formatValue = (val) => {
    if (val != null && val !== "") {
      const parseVal = ("" + val).replace(/\$\s?|(,*)/g, "");
      return parseVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "";
  };
  useEffect(() => {
    setValue(formatValue(props.value));
  }, [props.value]);
  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let cleanValue = value.replace(/[^0-9.-]+/g, "");
    const formattedValue = cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    console.log("formattedValue", formattedValue);
    console.log("cleanValue", cleanValue);
    setValue(formattedValue);
    if (props.onChange) {
      event.target.value = formattedValue;
      props.onChange(event);
    }
  };
  return (
    <div>
      <Input
        style={props.style ? props.style : null}
        addonBefore={"$"}
        placeholder="#,###,###.##"
        value={value}
        name={props.name}
        onChange={handleInputChange}
        disabled={props.disabled}
        size={"large"}
      />
    </div>
  );
};
export default Currency;
